import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reduceTriagePolicies } from '../../actions/policies/reduceTriagePolicies';
import { selectQuery } from '../../selectors/policies/selectQuery';
import { selectView } from '../../selectors/policies/selectView';

export function* queryTriagePoliciesSaga(action) {
    try {
        yield put(reduceLoading({ code: 'queryTriagePolicies', value: true }));
        const session = yield getSessionSaga();
        const view = yield select(selectView());
        let query = yield select(selectQuery());

        query = query[`${view}`];

        const response = yield call(fetch, '/api/policyTransaction/triage', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ policyQuery: { ...action.payload, ...query } }),
        });
        const result = yield call([response, 'json']);
        yield put(reduceOperation(result.operation));
        if (!result.operation.status) {
            yield put(reduceLoading({ code: 'queryTriagePolicies', value: false }));
            return;
        }
        yield put(reduceTriagePolicies(result.searchResult));
        yield put(reduceLoading({ code: 'queryTriagePolicies', value: false }));
        return;
    } catch (error) {
        console.log('Error while calling Query Policies API - ', error);
        yield put(reduceLoading({ code: 'queryTriagePolicies', value: false }));
        return;
    }
}
